export const ANALYTICS_TRIGGERS = Object.freeze({
  REGISTER_FORM: 'register_form',
  JOB_APPLY_REGISTER: 'job_apply_register',
  MATCH_CARD_APPLY: 'match_card_apply',
  JOB_OFFER_MODAL_APPLY: 'job_offer_modal_apply',
  JOB_OFFER_APPLY_CTA: 'job_offer_apply_cta',
  JOB_OFFER_APPLY_SUBMIT: 'job_offer_apply_submit',
  ONBOARDING: 'onboarding',
  JOB_APPLICATION: 'job_application',
  APPLICATION_FORM_SUBMIT: 'application_form_submit',
  APPLY: 'apply',
})
